import Card from "../UI/Card";
import LoginForm from "./LoginForm";


const Login = () => {
  return (
    <Card className="form-card">
      <LoginForm />
    </Card>
  );
};

export default Login;
